import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_order_routing_filter_drown",
  ref: "orderRequestProductRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-950px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_order_routing_filter_drown_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-400" }, null, -1)
const _hoisted_7 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-4 form-group mb-7" }
const _hoisted_12 = { class: "form-label fw-bold" }
const _hoisted_13 = { class: "col-md-4 form-group mb-7" }
const _hoisted_14 = { class: "form-label fw-bold" }
const _hoisted_15 = { class: "col-md-4 form-group mb-7" }
const _hoisted_16 = { class: "form-label fw-bold" }
const _hoisted_17 = { class: "col-md-4 form-group mb-7" }
const _hoisted_18 = { class: "form-label fw-bold" }
const _hoisted_19 = { class: "col-md-4 form-group mb-7" }
const _hoisted_20 = { class: "form-label fw-bold" }
const _hoisted_21 = { class: "col-md-4 form-group mb-7" }
const _hoisted_22 = { class: "form-label fw-bold" }
const _hoisted_23 = { class: "col-md-4 form-group mb-7" }
const _hoisted_24 = { class: "form-label fw-bold" }
const _hoisted_25 = {
  key: 0,
  class: "col-md-4 form-group mb-7"
}
const _hoisted_26 = { class: "form-label fw-bold" }
const _hoisted_27 = {
  key: 1,
  class: "col-md-4 form-group mb-7"
}
const _hoisted_28 = { class: "form-label fw-bold" }
const _hoisted_29 = {
  key: 2,
  class: "col-md-4 form-group mb-7"
}
const _hoisted_30 = { class: "form-label fw-bold" }
const _hoisted_31 = {
  key: 3,
  class: "col-md-4 form-group mb-7"
}
const _hoisted_32 = { class: "form-label fw-bold" }
const _hoisted_33 = { class: "col-md-4 form-group mb-7" }
const _hoisted_34 = { class: "form-label fw-bold" }
const _hoisted_35 = {
  key: 4,
  class: "col-md-4 form-group mb-7"
}
const _hoisted_36 = { class: "form-label fw-bold" }
const _hoisted_37 = {
  key: 5,
  class: "col-md-4 form-group mb-7"
}
const _hoisted_38 = { class: "form-label fw-bold" }
const _hoisted_39 = { class: "col-md-4 form-group mb-7" }
const _hoisted_40 = { class: "form-label fw-bold" }
const _hoisted_41 = {
  key: 6,
  class: "col-md-4 form-group mb-7"
}
const _hoisted_42 = { class: "form-label fw-bold" }
const _hoisted_43 = {
  key: 7,
  class: "col-md-4 form-group mb-7"
}
const _hoisted_44 = { class: "form-label fw-bold" }
const _hoisted_45 = { class: "modal-footer align-items-center justify-content-end gap-2 max-sm-justify-content-center" }
const _hoisted_46 = { class: "svg-icon svg-icon-3" }
const _hoisted_47 = { class: "svg-icon svg-icon-3" }
const _hoisted_48 = {
  class: "menu menu-sub menu-sub-dropdown w-250px w-md-800px",
  "data-kt-menu": "true"
}
const _hoisted_49 = { class: "px-7 py-5" }
const _hoisted_50 = { class: "fs-5 text-dark fw-bolder" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_52 = { class: "px-7 py-5" }
const _hoisted_53 = { class: "row max-sm-mh-300px" }
const _hoisted_54 = { class: "col-md-4 form-group mb-7" }
const _hoisted_55 = { class: "form-label fw-bold" }
const _hoisted_56 = { class: "col-md-4 form-group mb-7" }
const _hoisted_57 = { class: "form-label fw-bold" }
const _hoisted_58 = { class: "col-md-4 form-group mb-7" }
const _hoisted_59 = { class: "form-label fw-bold" }
const _hoisted_60 = { class: "col-md-4 form-group mb-7" }
const _hoisted_61 = { class: "form-label fw-bold" }
const _hoisted_62 = { class: "col-md-4 form-group mb-7" }
const _hoisted_63 = { class: "form-label fw-bold" }
const _hoisted_64 = { class: "col-md-4 form-group mb-7" }
const _hoisted_65 = { class: "form-label fw-bold" }
const _hoisted_66 = { class: "col-md-4 form-group mb-7" }
const _hoisted_67 = { class: "form-label fw-bold" }
const _hoisted_68 = {
  key: 0,
  class: "col-md-4 form-group mb-7"
}
const _hoisted_69 = { class: "form-label fw-bold" }
const _hoisted_70 = {
  key: 1,
  class: "col-md-4 form-group mb-7"
}
const _hoisted_71 = { class: "form-label fw-bold" }
const _hoisted_72 = {
  key: 2,
  class: "col-md-4 form-group mb-7"
}
const _hoisted_73 = { class: "form-label fw-bold" }
const _hoisted_74 = {
  key: 3,
  class: "col-md-4 form-group mb-7"
}
const _hoisted_75 = { class: "form-label fw-bold" }
const _hoisted_76 = { class: "col-md-4 form-group mb-7" }
const _hoisted_77 = { class: "form-label fw-bold" }
const _hoisted_78 = {
  key: 4,
  class: "col-md-4 form-group mb-7"
}
const _hoisted_79 = { class: "form-label fw-bold" }
const _hoisted_80 = {
  key: 5,
  class: "col-md-4 form-group mb-7"
}
const _hoisted_81 = { class: "form-label fw-bold" }
const _hoisted_82 = {
  key: 6,
  class: "col-md-4 form-group mb-7"
}
const _hoisted_83 = { class: "form-label fw-bold" }
const _hoisted_84 = {
  key: 7,
  class: "col-md-4 form-group mb-7"
}
const _hoisted_85 = { class: "form-label fw-bold" }
const _hoisted_86 = { class: "d-flex justify-content-end" }
const _hoisted_87 = { class: "svg-icon svg-icon-3" }
const _hoisted_88 = {
  type: "submit",
  class: "btn btn-sm btn-primary",
  "data-kt-menu-dismiss": "true"
}
const _hoisted_89 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_common_channel_option = _resolveComponent("common-channel-option")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_window_resize = _resolveComponent("window-resize")!

  return (_openBlock(), _createBlock(_component_window_resize, null, {
    sm: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form, {
            ref: "formRef",
            model: _ctx.formData
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", _hoisted_5, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.t("common.filterOptions")), 1)
                    ]),
                    _hoisted_6
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("salesOrder.orderNumber")) + ":", 1),
                      _createVNode(_component_el_form_item, {
                        prop: "order_number",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.order_number,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.order_number) = $event)),
                            type: "text",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("salesOrder.orderStatus")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "status" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "w-100",
                            modelValue: _ctx.formData.status,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.status) = $event)),
                            clearable: "",
                            multiple: "",
                            placeholder: _ctx.t('common.plsSelect')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.orderStatus, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("salesOrder.fulfillmentStatus")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "fulfillment_status" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "w-100",
                            modelValue: _ctx.formData.fulfillment_status,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.fulfillment_status) = $event)),
                            clearable: "",
                            multiple: "",
                            placeholder: _ctx.t('common.plsSelect')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.fulfillmentStatus, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("fulfillmentOrder.merchant")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "merchant" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "w-100",
                            ref: "selectMerchant",
                            onFocus: _ctx.cancelReadonly,
                            "onHook:mounted": _ctx.cancelReadonly,
                            onVisibleChange: _ctx.cancelReadonly,
                            teleported: false,
                            modelValue: _ctx.formData.merchant,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.merchant) = $event)),
                            filterable: "",
                            clearable: "",
                            "remote-show-suffix": "",
                            remote: "",
                            "remote-method": _ctx.searchMerchantSourceItems,
                            loading: _ctx.options.merchantLoading,
                            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getSalesChannelsData($event, true))),
                            placeholder: _ctx.t('common.plsSelect')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchant, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "remote-method", "loading", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t("fulfillmentOrder.channel")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "channel" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "w-100",
                            modelValue: _ctx.formData.channel,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.channel) = $event)),
                            clearable: "",
                            multiple: "",
                            loading: _ctx.options.channelLoading,
                            placeholder: _ctx.t('common.plsSelect')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.channel, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_common_channel_option, { channelOption: item }, null, 8, ["channelOption"])
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "loading", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.t("salesOrder.definiteInventoryType")) + ":", 1),
                      _createVNode(_component_el_form_item, {
                        prop: "definite_inventory_source",
                        onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "w-100",
                            modelValue: _ctx.formData.definite_inventory_source,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.definite_inventory_source) = $event)),
                            multiple: "",
                            clearable: "",
                            placeholder: _ctx.t('common.plsSelect')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.definite_inventory_source, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("order.brand")) + ":", 1),
                      _createVNode(_component_el_form_item, {
                        prop: "brand_name",
                        onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.brand_name,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.brand_name) = $event)),
                            type: "text",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    (!_ctx.isDoubleSale)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.t("salesOrder.orderDateStart")) + ":", 1),
                          _createVNode(_component_el_form_item, { prop: "order_date_start" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                class: "w-100",
                                modelValue: _ctx.formData.order_date_start,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.order_date_start) = $event)),
                                type: "date",
                                placeholder: _ctx.t('common.pickDate'),
                                teleported: false
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isDoubleSale)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.t("salesOrder.orderDateEnd")) + ":", 1),
                          _createVNode(_component_el_form_item, { prop: "order_date_end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                class: "w-100",
                                modelValue: _ctx.formData.order_date_end,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.order_date_end) = $event)),
                                type: "date",
                                placeholder: _ctx.t('common.pickDate'),
                                teleported: false
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isDoubleSale)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("salesOrder.businessDateStart")) + ":", 1),
                          _createVNode(_component_el_form_item, { prop: "business_date_start" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                class: "w-100",
                                modelValue: _ctx.formData.business_date_start,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.business_date_start) = $event)),
                                type: "date",
                                placeholder: _ctx.t('common.pickDate'),
                                teleported: false,
                                format: "YYYY-MM-DD",
                                "value-format": "YYYY-MM-DD"
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isDoubleSale)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.t("salesOrder.businessDateEnd")) + ":", 1),
                          _createVNode(_component_el_form_item, { prop: "business_date_end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                class: "w-100",
                                modelValue: _ctx.formData.business_date_end,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.business_date_end) = $event)),
                                type: "date",
                                placeholder: _ctx.t('common.pickDate'),
                                teleported: false,
                                format: "YYYY-MM-DD",
                                "value-format": "YYYY-MM-DD"
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.t("order.articleNo")) + ":", 1),
                      _createVNode(_component_el_form_item, {
                        prop: "brand_article_no",
                        onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.brand_article_no,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.brand_article_no) = $event)),
                            type: "text",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    (!_ctx.store_id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.t("salesOrder.dueDateStart")) + ":", 1),
                          _createVNode(_component_el_form_item, { prop: "inventory_confirm_date_start" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                class: "w-100",
                                modelValue: _ctx.formData.inventory_confirm_date_start,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.inventory_confirm_date_start) = $event)),
                                type: "date",
                                placeholder: _ctx.t('common.pickDate'),
                                teleported: false
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.store_id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.t("salesOrder.dueDateEnd")) + ":", 1),
                          _createVNode(_component_el_form_item, { prop: "inventory_confirm_date_end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                class: "w-100",
                                modelValue: _ctx.formData.inventory_confirm_date_end,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.inventory_confirm_date_end) = $event)),
                                type: "date",
                                placeholder: _ctx.t('common.pickDate'),
                                teleported: false
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.t("order.ean")) + ":", 1),
                      _createVNode(_component_el_form_item, {
                        prop: "ean",
                        onClick: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"]))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.ean,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.ean) = $event)),
                            type: "text",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    (!_ctx.store_id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.t("salesOrder.orderType")) + ":", 1),
                          _createVNode(_component_el_form_item, { prop: "order_type" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                modelValue: _ctx.formData.order_type,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.order_type) = $event)),
                                multiple: "",
                                clearable: "",
                                placeholder: _ctx.t('common.plsSelect')
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.order_type, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.store_id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.t("salesOrder.orderTagging")) + ":", 1),
                          _createVNode(_component_el_form_item, {
                            prop: "order_tagging",
                            onClick: _cache[23] || (_cache[23] = _withModifiers(() => {}, ["stop"]))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                modelValue: _ctx.formData.order_tagging,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.order_tagging) = $event)),
                                multiple: "",
                                clearable: "",
                                placeholder: _ctx.t('common.plsSelect')
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.order_tagging, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("button", {
                    type: "reset",
                    class: "btn btn-lg btn-light btn-active-light-primary me-2",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.handleReset && _ctx.handleReset(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_46, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr059.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.reset")), 1)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-lg btn-primary",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_47, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.apply")), 1)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ], 512)
    ]),
    lg: _withCtx(() => [
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.t("common.filterOptions")), 1)
        ]),
        _hoisted_51,
        _createElementVNode("div", _hoisted_52, [
          _createVNode(_component_el_form, {
            ref: "formRef",
            onSubmit: _cache[49] || (_cache[49] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.formData
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.t("salesOrder.orderNumber")) + ":", 1),
                  _createVNode(_component_el_form_item, {
                    prop: "order_number",
                    onClick: _cache[27] || (_cache[27] = _withModifiers(() => {}, ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.order_number,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.order_number) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter'),
                        clearable: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.t("salesOrder.orderStatus")) + ":", 1),
                  _createVNode(_component_el_form_item, { prop: "status" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        class: "w-100",
                        modelValue: _ctx.formData.status,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.status) = $event)),
                        clearable: "",
                        multiple: "",
                        placeholder: _ctx.t('common.plsSelect')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.orderStatus, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.t("salesOrder.fulfillmentStatus")) + ":", 1),
                  _createVNode(_component_el_form_item, { prop: "fulfillment_status" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        class: "w-100",
                        modelValue: _ctx.formData.fulfillment_status,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData.fulfillment_status) = $event)),
                        clearable: "",
                        multiple: "",
                        placeholder: _ctx.t('common.plsSelect')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.fulfillmentStatus, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.t("fulfillmentOrder.merchant")) + ":", 1),
                  _createVNode(_component_el_form_item, { prop: "merchant" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        class: "w-100",
                        ref: "selectMerchant",
                        onFocus: _ctx.cancelReadonly,
                        "onHook:mounted": _ctx.cancelReadonly,
                        onVisibleChange: _ctx.cancelReadonly,
                        teleported: false,
                        modelValue: _ctx.formData.merchant,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.formData.merchant) = $event)),
                        filterable: "",
                        clearable: "",
                        "remote-show-suffix": "",
                        remote: "",
                        "remote-method": _ctx.searchMerchantSourceItems,
                        loading: _ctx.options.merchantLoading,
                        onChange: _cache[31] || (_cache[31] = ($event: any) => (_ctx.getSalesChannelsData($event, true))),
                        placeholder: _ctx.t('common.plsSelect')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchant, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "remote-method", "loading", "placeholder"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.t("fulfillmentOrder.channel")) + ":", 1),
                  _createVNode(_component_el_form_item, { prop: "channel" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        class: "w-100",
                        modelValue: _ctx.formData.channel,
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.formData.channel) = $event)),
                        clearable: "",
                        multiple: "",
                        loading: _ctx.options.channelLoading,
                        placeholder: _ctx.t('common.plsSelect')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.channel, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_common_channel_option, { channelOption: item }, null, 8, ["channelOption"])
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "loading", "placeholder"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.t("salesOrder.definiteInventoryType")) + ":", 1),
                  _createVNode(_component_el_form_item, {
                    prop: "definite_inventory_source",
                    onClick: _cache[34] || (_cache[34] = _withModifiers(() => {}, ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        class: "w-100",
                        modelValue: _ctx.formData.definite_inventory_source,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formData.definite_inventory_source) = $event)),
                        multiple: "",
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.definite_inventory_source, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.t("order.brand")) + ":", 1),
                  _createVNode(_component_el_form_item, {
                    prop: "brand_name",
                    onClick: _cache[36] || (_cache[36] = _withModifiers(() => {}, ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.brand_name,
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.formData.brand_name) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter'),
                        clearable: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ]),
                (!_ctx.isDoubleSale)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                      _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.t("salesOrder.orderDateStart")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "order_date_start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            class: "w-100",
                            modelValue: _ctx.formData.order_date_start,
                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.formData.order_date_start) = $event)),
                            type: "date",
                            placeholder: _ctx.t('common.pickDate'),
                            teleported: false
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isDoubleSale)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                      _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.t("salesOrder.orderDateEnd")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "order_date_end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            class: "w-100",
                            modelValue: _ctx.formData.order_date_end,
                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.formData.order_date_end) = $event)),
                            type: "date",
                            placeholder: _ctx.t('common.pickDate'),
                            teleported: false
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isDoubleSale)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                      _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.t("salesOrder.businessDateStart")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "business_date_start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            class: "w-100",
                            modelValue: _ctx.formData.business_date_start,
                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.formData.business_date_start) = $event)),
                            type: "date",
                            placeholder: _ctx.t('common.pickDate'),
                            teleported: false,
                            format: "YYYY-MM-DD",
                            "value-format": "YYYY-MM-DD"
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isDoubleSale)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                      _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.t("salesOrder.businessDateEnd")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "business_date_end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            class: "w-100",
                            modelValue: _ctx.formData.business_date_end,
                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.formData.business_date_end) = $event)),
                            type: "date",
                            placeholder: _ctx.t('common.pickDate'),
                            teleported: false,
                            format: "YYYY-MM-DD",
                            "value-format": "YYYY-MM-DD"
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.t("order.articleNo")) + ":", 1),
                  _createVNode(_component_el_form_item, {
                    prop: "brand_article_no",
                    onClick: _cache[42] || (_cache[42] = _withModifiers(() => {}, ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.brand_article_no,
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.formData.brand_article_no) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter'),
                        clearable: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ]),
                (!_ctx.store_id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                      _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.t("salesOrder.dueDateStart")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "inventory_confirm_date_start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            class: "w-100",
                            modelValue: _ctx.formData.inventory_confirm_date_start,
                            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.formData.inventory_confirm_date_start) = $event)),
                            type: "date",
                            placeholder: _ctx.t('common.pickDate'),
                            teleported: false
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.store_id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                      _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.t("salesOrder.dueDateEnd")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "inventory_confirm_date_end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            class: "w-100",
                            modelValue: _ctx.formData.inventory_confirm_date_end,
                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.formData.inventory_confirm_date_end) = $event)),
                            type: "date",
                            placeholder: _ctx.t('common.pickDate'),
                            teleported: false
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.store_id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                      _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.t("salesOrder.orderType")) + ":", 1),
                      _createVNode(_component_el_form_item, { prop: "order_type" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "w-100",
                            modelValue: _ctx.formData.order_type,
                            "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.formData.order_type) = $event)),
                            multiple: "",
                            clearable: "",
                            placeholder: _ctx.t('common.plsSelect')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.order_type, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.store_id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                      _createElementVNode("label", _hoisted_85, _toDisplayString(_ctx.t("salesOrder.orderTagging")) + ":", 1),
                      _createVNode(_component_el_form_item, {
                        prop: "order_tagging",
                        onClick: _cache[47] || (_cache[47] = _withModifiers(() => {}, ["stop"]))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "w-100",
                            modelValue: _ctx.formData.order_tagging,
                            "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.formData.order_tagging) = $event)),
                            multiple: "",
                            clearable: "",
                            placeholder: _ctx.t('common.plsSelect')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.order_tagging, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_86, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-sm btn-light btn-active-light-primary me-2",
                  "data-kt-menu-dismiss": "true",
                  onClick: _cache[48] || (_cache[48] = 
//@ts-ignore
(...args) => (_ctx.handleReset && _ctx.handleReset(...args)))
                }, [
                  _createElementVNode("span", _hoisted_87, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr059.svg" })
                  ]),
                  _createTextVNode(_toDisplayString(_ctx.t("common.reset")), 1)
                ]),
                _createElementVNode("button", _hoisted_88, [
                  _createElementVNode("span", _hoisted_89, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ]),
                  _createTextVNode(_toDisplayString(_ctx.t("common.apply")), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ])
    ]),
    _: 1
  }))
}